<template>
  <!-- Detail section -->
  <div class="col-12 mt-3">
    <h5 class="mb-5">مشخصات اصلی:</h5>
    <div class="grid p-fluid mt-3">
      <div class="field col-12 md:col-3 lg:col-3 xl:col-2">
        <span class="p-float-label">
          <InputText
            v-model="service.title"
            @blur="v$.service.title.$touch"
            @input="v$.service.title.$touch"
            type="text"
            id="serviceTitleId"
            :class="{
              'border-red-500 hover:border-red-500 focus:shadow-none': v$.service.title.$error,
            }"
          />
          <label for="serviceTitleId">عنوان</label>
        </span>
        <small v-if="v$.service.title.required.$invalid && v$.service.title.$dirty" ref="password_error_message" class="text-red-500">
          {{ v$.service.title.required.$message }}
        </small>
      </div>
      <div class="field col-12 md:col-3 lg:col-3 xl:col-2">
        <span class="p-float-label">
          <InputNumber
            v-model="service.prepaymentPercentage"
            @blur="v$.service.prepaymentPercentage.$touch"
            @input="v$.service.prepaymentPercentage.$touch"
            class="input-Numbers"
            dir="ltr"
            id="percentId"
            mode="decimal"
            :min="1"
            :max="100"
            prefix="%"
            :useGrouping="false"
            :class="{
              'border-red-500 hover:border-red-500 focus:shadow-none p-invalid': v$.service.prepaymentPercentage.$error,
            }"
          />
          <label class="px-1" for="percentId">درصد پیش پرداخت</label>
        </span>
        <small v-if="v$.service.prepaymentPercentage.required.$invalid && v$.service.prepaymentPercentage.$dirty" ref="password_error_message" class="text-red-500">
          {{ v$.service.prepaymentPercentage.required.$message }}
        </small>
      </div>
      <div class="field col-12 md:col-3 lg:col-3 xl:col-2">
        <span class="p-float-label">
          <InputText
            v-model="service.standardCapacity"
            @input="v$.service.standardCapacity.$touch"
            @blur="v$.service.standardCapacity.$touch"
            type="Number"
            class="input-Numbers"
            dir="ltr"
            id="capacityId"
            mode="decimal"
            :max="100"
            :useGrouping="false"
            :class="{
              'border-red-500 hover:border-red-500 focus:shadow-non p-invalid': v$.service.standardCapacity.$error,
            }"
          />
          <label class="px-1" for="capacityId">ظرفیت(نفر)</label>
        </span>
        <small v-if="v$.service.standardCapacity.required.$invalid && v$.service.standardCapacity.$dirty" ref="password_error_message" class="text-red-500">
          {{ v$.service.standardCapacity.required.$message }}
        </small>
      </div>
      <div class="field col-12 md:col-3 lg:col-3 xl:col-2">
        <span class="p-float-label">
          <InputText
            v-model="service.additionalCapacity"
            @input="v$.service.additionalCapacity.$touch"
            @blur="v$.service.additionalCapacity.$touch"
            type="Number"
            class="input-Numbers"
            dir="ltr"
            id="moreCapacityId"
            mode="decimal"
            :max="100"
            :useGrouping="false"
            :class="{
              'border-red-500 hover:border-red-500 focus:shadow-none p-invalid': v$.service.additionalCapacity.$error,
            }"
          />
          <label class="px-1" for="moreCapacityId">ظرفیت اضافه(نفر)</label>
        </span>
        <small v-if="v$.service.additionalCapacity.required.$invalid && v$.service.additionalCapacity.$dirty" ref="password_error_message" class="text-red-500">
          {{ v$.service.additionalCapacity.required.$message }}
        </small>
      </div>
      <div class="field col-12 md:col-3 lg:col-3 xl:col-2">
        <Button label="Primary" @click="dialog['createRoom'] = true" class="p-button-outlined p-button-secondary justify-content-center">
          <span>تعداد</span>
          <span v-if="!!service.floorOfRooms.length">: </span>
          <span v-if="!!service.floorOfRooms.length">{{ sumOfFloorOfRooms }}</span>
        </Button>
      </div>
    </div>
  </div>
  <!-- Detail section -->
  <divider type="dashed" />
  <!-- Price section -->
  <div class="col-12">
    <h5 class="mb-5">قیمت گذاری:</h5>
    <div class="grid p-fluid mt-3">
      <div class="field col-12 md:col-4 lg:col-4 xl:col-4">
        <span class="p-float-label">
          <InputText
            v-model="service.price"
            @input="v$.service.price.$touch"
            @blur="v$.service.price.$touch"
            type="Number"
            class="input-Numbers"
            dir="ltr"
            id="moreCapacityId"
            mode="decimal"
            :class="{
              'border-red-500 hover:border-red-500 focus:shadow-none p-invalid': v$.service.price.$error,
            }"
          />
          <label for="serviceTitleId">قیمت روز عادی (تومان)</label>
        </span>
        <small v-if="v$.service.price.$invalid && v$.service.price.$dirty" ref="password_error_message" class="text-red-500">
          {{ v$.service.price.required.$message }}
        </small>
      </div>
      <div class="field col-12 md:col-4 lg:col-4 xl:col-4">
        <span class="p-float-label">
          <InputText
            v-model="service.peakDayPrice"
            @input="v$.service.peakDayPrice.$touch"
            @blur="v$.service.peakDayPrice.$touch"
            dir="ltr"
            type="Number"
            class="input-Numbers"
            id="moreCapacityId"
            mode="decimal"
            :class="{
              'border-red-500 hover:border-red-500 focus:shadow-none p-invalid': v$.service.peakDayPrice.$error,
            }"
          />
          <label for="serviceTitleId">قیمت روز پیک (تومان)</label>
        </span>
        <small v-if="v$.service.peakDayPrice.$invalid && v$.service.peakDayPrice.$dirty" ref="password_error_message" class="text-red-500">
          {{ v$.service.peakDayPrice.required.$message }}
        </small>
      </div>
      <div class="field col-12 md:col-4 lg:col-4 xl:col-4">
        <span class="p-float-label">
          <InputText
            v-model="service.additionalCapacityPrice"
            @input="v$.service.additionalCapacityPrice.$touch"
            @blur="v$.service.additionalCapacityPrice.$touch"
            dir="ltr"
            type="Number"
            class="input-Numbers"
            id="moreCapacityId"
            mode="decimal"
            :class="{
              'border-red-500 hover:border-red-500 focus:shadow-none p-invalid': v$.service.additionalCapacityPrice.$error,
            }"
          />
          <label for="serviceTitleId">قیمت هر نفر اضافه (تومان)</label>
        </span>
        <small v-if="v$.service.additionalCapacityPrice.$invalid && v$.service.additionalCapacityPrice.$dirty" ref="password_error_message" class="text-red-500">
          {{ v$.service.additionalCapacityPrice.required.$message }}
        </small>
      </div>
    </div>
  </div>
  <!-- Price section -->
  <divider type="dashed" />
  <!-- Beds section -->
  <div class="col-12">
    <h5 class="mb-5">تخت ها:</h5>
    <div class="grid p-fluid mt-3">
      <div class="field col-12 md:col-4 lg:col-4 xl:col-4">
        <span class="p-float-label">
          <InputText
            v-model="beds[0].count"
            @input="v$.beds[0].count.$touch"
            @blur="v$.beds[0].count.$touch"
            dir="ltr"
            type="Number"
            class="input-Numbers"
            id="moreCapacityId"
            mode="decimal"
            :useGrouping="false"
            :class="{
              'border-red-500 hover:border-red-500 focus:shadow-none p-invalid': v$.beds[0].count.$error,
            }"
          />
          <label for="serviceTitleId">تک نفره</label>
        </span>
        <small v-if="v$.beds[0].count.$invalid && v$.beds[0].count.$dirty" ref="password_error_message" class="text-red-500">
          {{ v$.beds[0].count.required.$message }}
        </small>
      </div>
      <div class="field col-12 md:col-4 lg:col-4 xl:col-4">
        <span class="p-float-label">
          <InputText
            v-model="beds[1].count"
            @input="v$.beds[1].count.$touch"
            @blur="v$.beds[1].count.$touch"
            dir="ltr"
            type="Number"
            class="input-Numbers"
            id="moreCapacityId"
            mode="decimal"
            :useGrouping="false"
            :class="{
              'border-red-500 hover:border-red-500 focus:shadow-none p-invalid': v$.beds[1].count.$error,
            }"
          />
          <label for="serviceTitleId">دو نفره</label>
        </span>
        <small v-if="v$.beds[1].count.$invalid && v$.beds[1].count.$dirty" ref="password_error_message" class="text-red-500">
          {{ v$.beds[1].count.required.$message }}
        </small>
      </div>
      <div class="field col-12 md:col-4 lg:col-4 xl:col-4">
        <span class="p-float-label">
          <InputText
            v-model="beds[2].count"
            @input="v$.beds[2].count.$touch"
            @blur="v$.beds[2].count.$touch"
            dir="ltr"
            id="moreCapacityId"
            type="Number"
            class="input-Numbers"
            :max="3"
            mode="decimal"
            :useGrouping="false"
            :class="{
              'border-red-500 hover:border-red-500 focus:shadow-none p-invalid': v$.beds[2].count.$error,
            }"
          />
          <label for="serviceTitleId">تعداد طبقه(نباید بیشتر از 3 باشد)</label>
        </span>
        <small v-if="v$.beds[2].count.$invalid && v$.beds[2].count.$dirty" ref="password_error_message" class="text-red-500">
          {{ v$.beds[2].count.required.$message }}
        </small>
      </div>
    </div>
  </div>
  <!-- Beds section -->
  <divider type="dashed" />
  <!-- Multi select tags section -->
  <div class="col-12">
    <h5 class="mb-5">تگ ها:</h5>
    <div class="grid p-fluid mt-3">
      <div class="field col-12 md:col-5">
        <MultiSelect v-model="service.tagsId" filterMatchMode :filter="true" :options="tags" optionLabel="title" optionValue="id" placeholder="انتخاب تگ مرتبط">
          <template #option="slotProps">
            <div class="flex flex-row gap-2">
              <img :src="'https://api.koome.net/' + slotProps.option.icon" :alt="slotProps.option.title" width="30" />
              <span>{{ slotProps.option.title }}</span>
            </div>
          </template>
        </MultiSelect>
      </div>
    </div>
  </div>
  <!-- Multi select tags section -->
  <divider type="dashed" />
  <!-- Meals section -->
  <div class="field col-12 mt-3">
    <h5 class="mb-5">وعده های غذایی:</h5>
    <div class="grid">
      <div v-for="(value, key, index) in service.meals" :key="`service-meals-${index}`" class="col-12 md:col-4">
        <div class="field-checkbox mb-0">
          <Checkbox :id="`checkMealOption${key}`" :binary="true" v-model="service.meals[key]" />
          <label class="mx-2" :for="`checkMealOption${key}`">{{ key == "hasBreakfast" ? "صبحانه" : key == "hasLunch" ? "ناهار" : "شام" }}</label>
        </div>
      </div>
    </div>
  </div>
  <!-- Meals section -->
  <div class="field col-12 flex flex-row justify-content-end mt-3">
    <span class="p-float-label md:w-2">
      <!-- :label="!!$route.params.place_id?'ویرایش':'ایجاد'" -->
      <Button type="button" class="mr-2 mb-2" :label="getRouterAction === 'edit' ? 'ویرایش' : 'ایجاد'" icon="pi pi-check" :loading="loading[getRouterAction]" @click="actionService()" />
    </span>
  </div>
  <!-- Create Room Dialog Section Begin -->
  <Dialog v-model:visible="dialog['createRoom']" :style="{ width: '1000px' }" header="تعریف اتاق جدید" :modal="true">
    <div class="grid p-fluid mt-3">
      <div class="field col-12 md:col-5">
        <span class="p-float-label">
          <InputText
            v-model="room.floor"
            @input="v$.room.floor.$touch"
            @blur="v$.room.floor.$touch"
            mode="decimal"
            type="Number"
            class="input-Numbers"
            id="floorId"
            :useGrouping="false"
            :class="{
              'border-red-500 hover:border-red-500 focus:shadow-none p-invalid': v$.room.floor.$error,
            }"
          />
          <label class="px-1" for="floorId">شماره طبقه</label>
        </span>
        <small v-if="v$.room.floor.$invalid && v$.room.floor.$dirty" ref="password_error_message" class="text-red-500">
          {{ v$.room.floor.required.$message }}
        </small>
      </div>
      <div class="field col-12 md:col-5">
        <span class="p-float-label">
          <InputText
            v-model="room.roomCount"
            @input="v$.room.roomCount.$touch"
            @blur="v$.room.roomCount.$touch"
            mode="decimal"
            type="Number"
            class="input-Numbers"
            id="roomId"
            :useGrouping="false"
            :class="{
              'border-red-500 hover:border-red-500 focus:shadow-none p-invalid': v$.room.roomCount.$error,
            }"
          />
          <label class="px-1" for="roomId">تعداد اتاق</label>
        </span>
        <small v-if="v$.room.roomCount.$invalid && v$.room.roomCount.$dirty" ref="password_error_message" class="text-red-500">
          {{ v$.room.roomCount.required.$message }}
        </small>
      </div>
      <div class="field col-12 md:col-2">
        <Button label="افزودن" icon="pi pi-plus" class="p-button-primary" @click="addRoom(room)" />
      </div>
      <div v-if="!!service.floorOfRooms.length" class="col-12">
        <div class="flex flex-row justify-content-start align-items-center flex-wrap gap-4">
          <div v-for="(item, index) in service.floorOfRooms" :key="index" class="border-1 p-2 border-round">
            <div class="flex flex-column">
              <span
                >طبقه: <strong>{{ item.floor }}</strong></span
              >
              <span
                >تعداد اتاق: <strong>{{ item.roomCount }}</strong></span
              >
            </div>
            <div class="text-center">
              <Button icon="pi pi-trash" class="p-button-rounded p-button-outlined p-button-text p-button-danger" @click="removeWithIndex(service.floorOfRooms, index)" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="text-left">
        <Button label="تایید" icon="pi pi-check" class="p-button-text" @click="assignQuantity" />
      </div>
    </template>
  </Dialog>
  <!-- Create Room Dialog Section Ended -->
</template>

<script>
import { required, minLength, maxLength, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
export default {
  name: "ServiceDetails",
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      crudType: "create",
      dialog: {
        createRoom: false,
      },
      ids: {
        place: null,
        service: null,
      },
      loading: {
        create: false,
        edit: false,
      },
      service: {
        title: "",
        quantity: null,
        prepaymentPercentage: null,
        standardCapacity: null,
        price: null,
        peakDayPrice: null,
        additionalCapacity: null,
        additionalCapacityPrice: null,
        isWednesdayWeekend: false,
        meals: {
          hasBreakfast: false,
          hasLunch: false,
          hasDinner: false,
        },
        beds: [],
        floorOfRooms: [],
        tagsId: [],
      },
      beds: [
        { bedType: 0, count: null },
        { bedType: 1, count: null },
        { bedType: 2, count: null },
      ],
      room: {
        floor: null,
        roomCount: null,
      },
      tags: [],
      selectedTags: [],
    };
  },
  computed: {
    getRouterAction() {
      const { place_id, type, service_id } = { ...this.$route.params };
      this.ids.place = place_id;
      this.ids.service = service_id;
      this.crudType = type;
      if (this.crudType == "edit") {
        this.getService(service_id);
        this.getTagsList();
      }
      return this.crudType;
    },
    sumOfFloorOfRooms() {
      return this.service.floorOfRooms.reduce((a, b) => a + (b["roomCount"] || 0), 0);
    },
  },
  watch: {
    getRouterAction() {},
  },
  methods: {
    //******* Api methods begin *******//
    actionService() {
      if (this.getRouterAction === "create") {
        this.createService();
      } else {
        this.updateService(this.ids.service);
      }
    },
    async getService(id) {
      const { status, data } = await this.axios({ method: "get", url: `Place/${this.ids.place}/Service/${id}` });
      this.service = { ...data };
      this.service.beds.forEach((item, index) => {
        if (item.count != 0) {
          this.beds[index] = item;
        }
      }),
        (this.service.tagsId = data.tags.map(({ id }) => id));
    },
    async getTagsList(query = "", page = 1, pageSize = 10) {
      const { status, data } = await this.axios({ method: "get", url: `Tag/GetAll?TitleQuery=${query}&PageIndex=1&PageSize=10` });
      this.pageSize = data.pageSize;
      this.tags = [...data.data];
    },
    async createService() {
      this.service.beds = this.filterExistBeds();
      // this.service.placeId = this.$route.params.placeId
      this.loading["create"] = true;
      const { status, data } = await this.axios({ method: "post", url: `Place/${this.ids.place}/Service`, data: this.service });
      this.showToast(status, data.errors);
      this.loading["create"] = false;
      if (status === 200) {
        setTimeout(() => {
          this.$router.push({ name: "serviceDetails", params: { place_id: this.ids.place, type: "edit", service_id: data } });
        }, 1500);
      }
    },
    async updateService(_id) {
      this.service.beds = this.filterExistBeds();
      this.loading["edit"] = true;
      const { status, data } = await this.axios({ method: "put", url: `Place/${this.ids.place}/Service/${this.ids.service}`, data: this.service });
      this.showToast(status, data.errors);
      this.loading["edit"] = false;
    },
    //******* Api methods begin *******//
    addRoom() {
      this.service.floorOfRooms.push(this.room);
      this.room = { floor: null, roomCount: null };
    },
    removeWithIndex(array, index) {
      array.splice(index, 1);
    },
    assignQuantity() {
      this.service.quantity = this.sumOfFloorOfRooms;
      this.dialog["createRoom"] = false;
    },
    filterExistBeds() {
      return this.beds.filter((item) => !!item.count);
    },
  },
  mounted() {
    this.getTagsList();
  },
  validations() {
    return {
      service: {
        title: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
        prepaymentPercentage: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
        standardCapacity: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
        additionalCapacity: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
        price: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
        peakDayPrice: {
          required: helpers.withMessage("این فیلد الزامی است", required),
        },
        additionalCapacityPrice: {
          required: helpers.withMessage("این فیلد الزامی است", required),
        },
      },
      room: {
        floor: {
          required: helpers.withMessage("این فیلد الزامی است", required),
        },
        roomCount: {
          required: helpers.withMessage("این فیلد الزامی است", required),
        },
      },
      beds: [
        {
          count: {
            required: helpers.withMessage("این فیلد الزامی است", required),
            $dirty: false,
          },
        },
        {
          count: {
            required: helpers.withMessage("این فیلد الزامی است", required),
            $dirty: false,
          },
        },
        {
          count: {
            required: helpers.withMessage("این فیلد الزامی است", required),
            $dirty: false,
          },
        },
      ],
    };
  },
};
</script>
<style lang="scss">
.input-Numbers::-webkit-outer-spin-button,
.input-Numbers::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.input-Numbers[type="number"] {
  -moz-appearance: textfield;
}
</style>
